<div id="continue-playing">
    <div class="inner">
        <div class="container"></div>
    </div>
</div>